
        <div #carouselItem class="ui-carousel-item fade" [ngStyle]="transition" swiper tabindex="-1" style="outline: none">
        <ng-content></ng-content>
        </div>
   